import { DeleteAppointmentMainAction } from "./appointments.delete.main.types";

export const deleteAppointmentMainRequestAction = (params: { medic_user_id: number; appointment_id: number }): DeleteAppointmentMainAction => ({ type: 'DELETE_APPOINTMENT_MAIN_REQUEST', params })

export const deleteAppointmentMainSuccessAction = (): DeleteAppointmentMainAction => ({ type: 'DELETE_APPOINTMENT_MAIN_SUCCESS' })

export const deleteAppointmentMainFailureAction = (error?: any): DeleteAppointmentMainAction => ({ type: 'DELETE_APPOINTMENT_MAIN_FAILURE', params: error })